<template>
  <section class="register">
    <div class="box">
      <div class="header">
        <div key="info" class="title">Cadastro de Produto</div>
        <div @click="$router.push('/product')" class="close"><i class="fas fa-times"></i></div>
      </div>
      <form @submit.prevent class="form">
        <Selector v-model="active" :options="activeOptions" class="selector_change"/>
        <!-- Nome -->
        <label>Nome</label>
        <input v-model="name" type="text" placeholder="Nome do produto" :class="{ error : error.includes('name') }" />
        <div v-if="error.indexOf('name') > -1" class="hint">você esqueceu de digitar o nome</div>
        <!--Descrição -->
        <label>Descrição</label>
        <textarea v-model="desc" rows="3" :class="{ error : error.indexOf('desc') > -1 }" />
        <div v-if="error.indexOf('desc') > -1" class="hint">você esqueceu de digitar a descrição</div>
        <!-- Profit -->
        <label class="switch">
          <input v-model="pf" type="checkbox">
          <span class="slider"></span>
          <span class="text" style="margin-left: 0px;">Profit</span>
        </label>
        <!-- TraddingView -->
        <label class="switch" style="margin-top: 0px;">
          <input v-model="tv" type="checkbox">
          <span class="slider"></span>
          <span class="text" style="margin-left: 0px;">TraddingView</span>
        </label>
        <!-- NinjaTrader -->
        <label class="switch" style="margin-top: 0px;">
          <input v-model="nj" type="checkbox">
          <span class="slider"></span>
          <span class="text" style="margin-left: 0px;">NinjaTrader</span>
        </label>
        <!-- BlackArrow -->
        <label class="switch" style="margin-top: 0px;">
          <input v-model="ba" type="checkbox">
          <span class="slider"></span>
          <span class="text" style="margin-left: 0px;">BlackArrow</span>
        </label>
        <!-- Profit Bot Yan-->
        <label class="switch">
          <input v-model="pfBotYan" type="checkbox">
          <span class="slider"></span>
          <span class="text" style="margin-left: 0px;">Profit - Bot Yan</span>
        </label>
        <!-- NinjaTrader Bot Yan -->
        <label class="switch" style="margin-top: 0px;">
          <input v-model="njBotYan" type="checkbox">
          <span class="slider"></span>
          <span class="text" style="margin-left: 0px;">NinjaTrader - Bot Yan</span>
        </label>
        <!-- BlackArrow Bot Yan-->
        <label class="switch" style="margin-top: 0px;">
          <input v-model="baBotYan" type="checkbox">
          <span class="slider"></span>
          <span class="text" style="margin-left: 0px;">BlackArrow - Bot Yan</span>
        </label>
        <!--Preço -->
        <label>Preço</label>
        <!-- <input v-model="price" type="text" placeholder="Preço do produto" :class="{ error : error.includes('desc') }" /> -->
        <money v-bind="formatMoney" v-model="price" :class="{ error : error.indexOf('price') > -1 }"></money>
        <div v-if="error.includes('price')" class="hint">você esqueceu de digitar o preço</div>
        <!-- Promoção -->
        <label class="switch">
          <input v-model="promotion" type="checkbox">
          <span class="slider"></span>
          <span class="text" style="margin-left: 0px;">{{ this.promotion ? 'Promoção ativada' : 'Promoção desativada' }}</span>
        </label>
        <div v-if="this.promotion" class="form-search" style="display: flex; justify-content: space-between; align-items: center">
          <select v-model="type" :change="setFormat()" style="width: 180px">
            <option value="percent">Desconto percentual</option>
            <!-- <option value="value">Desconto por valor</option> -->
            <option value="fixed">Valor fixo</option>
          </select>
          <div style="flex-basis: 45%">
            <!--<input :disabled="!show" v-model="discount" type="number" placeholder="Valor" :class="{ error : error.indexOf('discount') > -1 }" style="width:130px;float:right;"/>-->
            <money v-bind="formatMoney2" v-model="discount" :class="{ error : error.indexOf('discount') > -1 }" style="width:130px;float:right;"></money>
          </div>
        </div>
        <!-- Validade -->
        <label v-if="promotion">Validade</label>
        <input v-if="promotion" v-model="expiration" v-on:keydown="validade" type="date" :min="(new Date()).toISOString().split('T')[0]" :class="{ error : error.indexOf('expiration') > -1 }"/>
        <div v-if="error.indexOf('expiration') > -1" class="hint">Validade inválida</div>
      </form>
      <div class="actions">
        <button @click="$router.push('/product')" class="button-previous"><i class="fas fa-angle-left"></i><span>Cancelar</span></button>
        <button @click="save" class="button-save"><i class="fas" :class="loading ? 'fa-spinner loading' : 'fa-check'"></i><span>Confirmar</span></button>
      </div>
    </div>
  </section>
</template>

<script>
import logger from '../../logger'
import { create, update } from '../api/product'
import Selector from './Selector'

export default {
  name: 'product',
  components: { Selector },
  props: ['id', 'productData'],
  data () {
    return {
      loading: false,
      error: [],
      name: null,
      desc: null,
      price: null,
      active: null,
      promotion: false,
      type: null,
      discount: null,
      expiration: null,
      maxDate: null,
      pf: false,
      tv: false,
      nj: false,
      ba: false,
      njBotYan: false,
      pfBotYan: false,
      baBotYan: false,
      //bot: false,
      formatMoney: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false
      },
      formatMoney2: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false
      },
      activeOptions: [
        {
          value: true,
          text: 'ATIVO'
        },
        {
          value: false,
          text: 'INATIVO'
        }
      ]
    }
  },
  async mounted () {
    if (this.id !== 'new') {
      this.name = this.productData.name
      this.desc = this.productData.desc
      this.price = this.productData.price
      this.active = this.productData.active
      this.promotion = this.productData.promotion
      this.type = this.productData.type
      this.discount = this.productData.discount
      this.expiration = this.productData.expiration ? String(this.productData.expiration).split('/')[2] + '-' + String(this.productData.expiration).split('/')[1] + '-' + String(this.productData.expiration).split('/')[0] : null
      this.pf = this.productData.pf
      this.tv = this.productData.tv
      this.nj = this.productData.nj
      this.ba = this.productData.ba
      this.njBotYan = this.productData.njBotYan
      this.pfBotYan = this.productData.pfBotYan
      this.baBotYan = this.productData.baBotYan
      //this.bot = this.productData.bot
    } else {
      this.active = true
    }
  },
  methods: {
    validade (e) {
      e.preventDefault()
    },
    setFormat () {
      if (this.type === 'percent') {
        this.formatMoney2.decimal = ''
        this.formatMoney2.thousands = ''
        this.formatMoney2.prefix = ''
        this.formatMoney2.suffix = ' %'
        this.formatMoney2.precision = 0
      } else {
        this.formatMoney2.decimal = ','
        this.formatMoney2.thousands = '.'
        this.formatMoney2.prefix = 'R$ '
        this.formatMoney2.suffix = ''
        this.formatMoney2.precision = 2
      }
    },
    async save () {
      try {
        if (this.loading) return false
        this.loading = true
        this.error = []
        if (this.id === 'new') {
          await create(this.name, this.desc, this.price, this.active, this.promotion, this.type, this.discount, this.expiration, this.pf, this.tv, this.nj, this.ba, this.njBotYan, this.pfBotYan, this.baBotYan)
        } else {
          await update(this.id, this.name, this.desc, this.price, this.active, this.promotion, this.type, this.discount, this.expiration, this.pf, this.tv, this.nj, this.ba, this.njBotYan, this.pfBotYan, this.baBotYan)
        }
        this.loading = false
        this.$router.push('/product')
      } catch (error) {
        const data = error.response ? error.response.data : {}
        // Validation error
        if (data.error === 'Validation error') {
          this.error = data.fields
        } else {
          logger.error(error, this)
        }
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../_asset/scss/_variables";
.selector_change {
    background-color: #cccccc;
    color: #595959;
    font-size: 0.8em;
    padding: 2.5px;
}
</style>
